import React, { useState } from "react";

const build = (n) =>
  Array.from({ length: n }).map((_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${70 + Math.random() * 40}%`,
    duration: 9 + Math.random() * 9,
    delay: -Math.random() * 12,
    scale: 0.6 + Math.random() * 1.4,
  }));

export const DustParticles = ({ count = 20, className = "" }) => {
  const [dust] = useState(() => build(count));
  return (
    <div aria-hidden className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {dust.map((d) => (
        <span
          key={d.id}
          className="dust"
          style={{
            left: d.left,
            top: d.top,
            animationDuration: `${d.duration}s`,
            animationDelay: `${d.delay}s`,
            transform: `scale(${d.scale})`,
          }}
        />
      ))}
    </div>
  );
};

export default DustParticles;
